import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter , ModalHeader } from 'reactstrap';
import store from '../../../store/store';

class ModalBase extends Component {

	constructor(props) {
	    super(props);
		    this.state = {
		    modal: false,
		};
	}
	
	toggleModal = () => {
	    this.setState({
	      modal: !this.state.modal,
	    });
	}

	actionModal= () =>{
		if(this.props.confirmFunc){
			this.props.confirmFunc()
			this.toggleModal()
		}else{
			this.toggleModal()
		}
	}

	render () {
		return (
		<Modal isOpen={this.state.modal}
		 toggle={this.toggleModal}
		 className={this.props.className ? this.props.className : '' }
		 style={this.props.style ? this.props.style : {}}
		>
			<ModalHeader toggle={this.toggleModal}>
				{this.props.title? this.props.title : '' }
			</ModalHeader>
			<ModalBody>
				{ this.props.html }
			</ModalBody>
			{
				this.props.confirmFunc ?
					<ModalFooter>
						<Button 
							disabled={this.props.disabled || false}
							color = {`${this.props.isDelete ? 'danger' : 'primary'}`} 
							onClick = { this.actionModal } >
							{
								this.props.isDelete 
								? store.getState().json_lang.common.delete
								: (
									this.props.isPay
									? store.getState().json_lang.common.pay
									: store.getState().json_lang.common.save
								)
							}
						</Button>
						<Button color = "secondary" onClick = { this.toggleModal } >
							{store.getState().json_lang.common.cancel}
						</Button>
					</ModalFooter>
				: null
			}
		</Modal>
		)
	}
}

export default ModalBase



// WEBPACK FOOTER //
// ./src/views/Plugins/MainModals/ModalBase.jsx